import React, { useEffect, useState } from "react";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";

export function ClientIdsTab({ summary, onChange }) {
  const [preview, setPreview] = useState([]);
  const [busy, setBusy] = useState(false);
  const live = summary?.ids_live;
  useEffect(() => { if (summary && !live) api.get("/client-master/id-preview").then((r) => setPreview(r.data)); }, [summary, live]);

  async function assign() {
    if (!window.confirm(`Assign Client IDs to ${preview.length} active clients now? This can only be done once; IDs are permanent and never reused.`)) return;
    setBusy(true);
    try { const r = await api.post("/client-master/assign-ids"); toast.success(`${r.data.assigned} Client IDs assigned`); onChange(); }
    catch (e) { toast.error(formatErr(e.response?.data?.detail)); }
    setBusy(false);
  }

  if (!summary) return null;
  if (live) return (
    <div className="card-flat p-6 text-sm" data-testid="ids-live">
      <div className="font-medium mb-1">Client IDs are live.</div>
      <div className="text-[var(--ink-2)]">Last issued: <span className="font-mono-data" data-testid="ids-last-issued">FBSCL-{String(summary.last_issued).padStart(5, "0")}</span> · Active clients without an ID: <span data-testid="ids-without">{summary.without_id}</span></div>
      <div className="text-[var(--ink-2)] mt-2">New clients get the next ID automatically. Archived clients release theirs; a reactivated client gets a new one. IDs are never reused.</div>
    </div>
  );
  return (
    <div data-testid="ids-pending">
      <div className="card-flat p-5 mb-4 text-sm border-l-4 border-l-[var(--gold)]">
        Finish data cleansing first, then assign IDs. Every active client gets a permanent ID, starting at <b className="font-mono-data">FBSCL-00301</b>, ordered by relationship start date (falling back to date of engagement; clients with neither go last).
        <div className="mt-3"><button data-testid="ids-assign-btn" disabled={busy || !preview.length} onClick={assign} className="btn-primary">{busy ? "Assigning…" : `Assign Client IDs to ${preview.length} clients`}</button></div>
      </div>
      <table className="tbl tbl-ultra" data-testid="ids-preview">
        <thead><tr><th>Client ID (preview)</th><th>Client</th><th>Relationship start</th><th>Engagement date</th></tr></thead>
        <tbody>
          {preview.slice(0, 200).map((p) => (
            <tr key={p.client_uid}><td className="font-mono-data text-xs">{p.client_uid}</td><td>{p.client_name}</td><td className="text-xs">{p.relationship_start_date || "—"}</td><td className="text-xs">{p.engagement_date || "—"}</td></tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
